<template>
  <v-nav>
    <a-row :gutter="16" style="padding-top: 20px">
      <a-col :span="6">
        <div style="width: 100%;background-color: white" class="cibr-statistic">
          <a-anchor  @click="handleAnchorClick" :affix="false">
            <a-anchor-link href="jldzbjg" title="聚类点坐标结果"/>
            <a-anchor-link href="fcfm" title="FC计算结果（食指和中指）"/>
            <a-anchor-link href="fcrw" title="FC计算结果（环指和手腕）"/>
            <a-anchor-link href="tmssz" title="TMS验证健康被试伸展阳性点在MNI标准空间的坐标"/>
            <a-anchor-link href="tmsqq" title="TMS验证健康被试屈曲阳性点在MNI标准空间的坐标"/>
            <a-anchor-link href="fzydqssxu" title="辅助运动区损伤与修复（HBM，2022）"/>
            <a-anchor-link href="zcbq" title="左侧半球脑胶质瘤患者的感觉运动网络节点MNI坐标"/>
            <a-anchor-link href="ycbq" title="右侧半球脑胶质瘤患者的感觉运动网络节点MNI坐标"/>
          </a-anchor>
        </div>
      </a-col>
      <a-col :span="18" style="background-color: white">
        <div style="padding: 16px 48px;width: 100%;overflow: auto" :style="{height : contentHeight}">
          <h1 style="color: black" id="jldzbjg">聚类点坐标结果</h1>
          <table>
            <tr class="table-title" style="border-top: 2px solid black">
              <td colspan="2" rowspan="2">Parts of Hand</td>
              <td colspan="3">Coordinates</td>
            </tr>
            <tr class="table-title" style="border-bottom: 2px solid black;border-top: 1px solid black">
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
            </tr>
            <tr class="table-bg-grey">
              <td rowspan="5">Thumb</td>
              <td>Flex 1</td>
              <td>36.3</td>
              <td>-20.1</td>
              <td>70.6</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Flex 2</td>
              <td>48.4</td>
              <td>-10.1</td>
              <td> 58.9</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Flex 3</td>
              <td>44.1</td>
              <td>-15.2</td>
              <td> 65.2</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 1</td>
              <td>60.3</td>
              <td>-15.0</td>
              <td> 47.6</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 2</td>
              <td>47.0</td>
              <td>-28.4</td>
              <td> 63.8</td>
            </tr>
            <tr>
              <td rowspan="10">Forefinger</td>
              <td>Extend 1</td>
              <td>37.6</td>
              <td>-14.6</td>
              <td> 69.1</td>
            </tr>
            <tr>
              <td>Extend 2</td>
              <td>48.1</td>
              <td>-6.6</td>
              <td>60.0</td>
            </tr>
            <tr>
              <td>Extend 3</td>
              <td>29.0</td>
              <td>-14.6</td>
              <td> 75.2</td>
            </tr>
            <tr>
              <td>Extend 4</td>
              <td>39.7</td>
              <td>-8.4</td>
              <td>66.5</td>
            </tr>
            <tr>
              <td>Flex 1</td>
              <td>33.4</td>
              <td>-21.7</td>
              <td> 72.8</td>
            </tr>
            <tr>
              <td>Flex 2</td>
              <td>42.6</td>
              <td>-17.4</td>
              <td> 66.5</td>
            </tr>
            <tr>
              <td>Flex 3</td>
              <td>49.3</td>
              <td>-9.3</td>
              <td>58.6</td>
            </tr>
            <tr>
              <td>Numbness 1</td>
              <td>61.6</td>
              <td>-14.2</td>
              <td> 45.6</td>
            </tr>
            <tr>
              <td>Numbness 2</td>
              <td>42.6</td>
              <td>-30.2</td>
              <td> 67.0</td>
            </tr>
            <tr>
              <td>Numbness 3</td>
              <td>52.4</td>
              <td>-19.0</td>
              <td> 57.9</td>
            </tr>
            <tr class="table-bg-grey">
              <td rowspan="7">Middle finger</td>
              <td>Extend 1</td>
              <td>39.0</td>
              <td>-12.2</td>
              <td> 67.5</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend 2</td>
              <td>53.0</td>
              <td>-7.5</td>
              <td>53.0</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend 3</td>
              <td>30.7</td>
              <td>-15.7</td>
              <td> 74.4</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Flex 1</td>
              <td>46.2</td>
              <td>-13.1</td>
              <td> 62.8</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Flex 2</td>
              <td>35.8</td>
              <td>-21.2</td>
              <td> 71.2</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 1</td>
              <td>53.8</td>
              <td>-18.4</td>
              <td> 55.9</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 2</td>
              <td>37.8</td>
              <td>-32.6</td>
              <td> 70.2</td>
            </tr>
            <tr>
              <td rowspan="8">Ringer finger</td>
              <td>Extend 1</td>
              <td>27.8</td>
              <td>-15.2</td>
              <td> 76.0</td>
            </tr>
            <tr>
              <td>Extend 2</td>
              <td>35.9</td>
              <td>-15.4</td>
              <td> 71.1</td>
            </tr>
            <tr>
              <td>Extend 3</td>
              <td>36.3</td>
              <td>-9.0</td>
              <td>68.0</td>
            </tr>
            <tr>
              <td>Flex 1</td>
              <td>35.6</td>
              <td>-21.4</td>
              <td> 71.2</td>
            </tr>
            <tr>
              <td>Flex 2</td>
              <td>45.7</td>
              <td>-12.3</td>
              <td> 65.7</td>
            </tr>
            <tr>
              <td>Numbness 1</td>
              <td>39.8</td>
              <td>-31.8</td>
              <td> 68.8</td>
            </tr>
            <tr>
              <td>Numbness 2</td>
              <td>50.1</td>
              <td>-20.1</td>
              <td> 61.5</td>
            </tr>
            <tr>
              <td>Numbness 3</td>
              <td>59.4</td>
              <td>-16.3</td>
              <td> 52.0</td>
            </tr>
            <tr class="table-bg-grey">
              <td rowspan="5">Little finger</td>
              <td>Flex 1</td>
              <td>25.2</td>
              <td>-20.5</td>
              <td> 76.9</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Flex 2</td>
              <td>35.5</td>
              <td>-17.8</td>
              <td> 70.3</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 1</td>
              <td>34.3</td>
              <td>-28.1</td>
              <td> 72.1</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 2</td>
              <td>44.7</td>
              <td>-30.9</td>
              <td> 66.1</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numbness 3</td>
              <td>47.0</td>
              <td>-28.8</td>
              <td> 64.2</td>
            </tr>
            <tr>
              <td rowspan="5">Wrist</td>
              <td>Extend 1</td>
              <td>25.2</td>
              <td>-17.5</td>
              <td> 76.9</td>
            </tr>
            <tr>
              <td>Extend 2</td>
              <td>35.5</td>
              <td>-13.8</td>
              <td> 70.3</td>
            </tr>
            <tr>
              <td>Extend 3</td>
              <td>44.7</td>
              <td>-8.9</td>
              <td>63.1</td>
            </tr>
            <tr>
              <td>Flex 1</td>
              <td>34.3</td>
              <td>-21.1</td>
              <td> 72.1</td>
            </tr>
            <tr>
              <td>Flex 2</td>
              <td>47.0</td>
              <td>-10.8</td>
              <td> 61.2</td>
            </tr>
          </table>
          <div class="table-explanation">
            解释：针对每类动作，采用k-means聚类方式，根据最佳聚类算法，确定了聚类数量，并提供了每类动作聚类点的MNI坐标。基于这些坐标，进行了种子点的生成，并用于计算FC。
          </div>
          <a-divider style="background-color: black"/>
          <h1 style="color: black" id="fcfm">FC计算结果（食指和中指）</h1>
          <table>
            <tr class="table-sub-title">
              <td colspan="4">Forefinger</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Flex_all to Numb_1</td>
              <td>Flex_all to Numb_2</td>
              <td>Flex_all to Numb_3</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_1</td>
              <td>E: 0.395 ± 0.029<br/>F: 0.557 ± 0.035<br/>p = 0.0004</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_3</td>
              <td>-</td>
              <td>E: 0.507 ± 0.035<br/>F: 0.758 ± 0.037<br/>p &lt; 0.0001</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_3</td>
              <td>-</td>
              <td>-</td>
              <td>E: 0.523 ± 0.031<br/>F: 0.843 ± 0.034<br/>p &lt; 0.0001</td>
            </tr>
            <tr class="tr-title">
              <td></td>
              <td>Numb_all to Flex_1</td>
              <td>Numb_all to Flex_2</td>
              <td>Numb_all to Flex_3</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_1</td>
              <td> E: 0.606 ± 0.034<br/>F: 0.755 ± 0.035<br/>p = 0.0025</td>
              <td>E: 0.606 ± 0.034<br/>F: 0.734 ± 0.039<br/>p = 0.0133*</td>
              <td> E: 0.606 ± 0.034<br/>F: 0.668 ± 0.038<br/>p = 0.2226*</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_2</td>
              <td> E: 0.407 ± 0.034<br/>F: 0.755 ± 0.035<br/>p &lt; 0.0001</td>
              <td> E: 0.407 ± 0.034<br/>F: 0.734 ± 0.039<br/>p &lt; 0.0001</td>
              <td> E: 0.407 ± 0.034<br/>F: 0.668 ± 0.038<br/>p &lt; 0.0001</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_3</td>
              <td> E: 0.460 ± 0.038<br/>F: 0.755 ± 0.035<br/>p &lt; 0.0001</td>
              <td> E: 0.460 ± 0.038<br/>F: 0.734 ± 0.039<br/>p &lt; 0.0001</td>
              <td> E: 0.460 ± 0.038<br/>F: 0.668 ± 0.038<br/>p = 0.0001</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_4</td>
              <td> E: 0.428 ± 0.039<br/>F: 0.755 ± 0.035<br/>p &lt; 0.0001</td>
              <td> E: 0.428 ± 0.039<br/>F: 0.734 ± 0.039<br/>p &lt; 0.0001</td>
              <td> E: 0.428 ± 0.039<br/>F: 0.668 ± 0.038<br/>p &lt; 0.0001</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td colspan="2">Numb_all to Flex_all</td>
              <td>p value</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numb_all to Extend_all</td>
              <td colspan="2">E: 0.475 ± 0.019 <br/>F: 0.719 ± 0.021</td>
              <td>&lt; 0.0001</td>
            </tr>
          </table>
          <table>
            <tr class="table-sub-title">
              <td colspan="3">Middle finger</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Flex_all to Numb_1</td>
              <td>Flex_all to Numb_2</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_1</td>
              <td>E: 0.559 ± 0.036<br/>F: 0.907 ± 0.041<br/>p &lt; 0.0001</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_2</td>
              <td>-</td>
              <td>E: 0.523 ± 0.041<br/>F: 0.727 ± 0.043<br/>p = 0.0012</td>
            </tr>
            <tr class="tr-title">
              <td></td>
              <td>Numb_all to Flex_1</td>
              <td>Numb_all to Flex_2</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_1</td>
              <td> E: 0.659 ± 0.048<br/>F: 0.812 ± 0.047<br/>p = 0.0251*</td>
              <td> E: 0.659 ± 0.048<br/>F: 0.821 ± 0.040<br/>p = 0.0110*</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_2</td>
              <td> E: 0.405 ± 0.037<br/>F: 0.812 ± 0.047<br/>p &lt; 0.0001</td>
              <td> E: 0.405 ± 0.037<br/>F: 0.821 ± 0.040<br/>p &lt; 0.0001</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_3</td>
              <td> E: 0.559 ± 0.051<br/>F: 0.812 ± 0.047<br/>p = 0.0004</td>
              <td> E: 0.559 ± 0.051<br/>F: 0.821 ± 0.040<br/>p &lt; 0.0001</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Numb_all to Flex_all</td>
              <td>p value</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numb_all to Extend_all</td>
              <td>E: 0.541 ± 0.027 <br/>F: 0.817 ± 0.031</td>
              <td>&lt; 0.0001</td>
            </tr>
          </table>
          <p style="font-size: 16px">The p value with ‘*’ means that the result is insignificant after Bonferroni
            correction. The letter ‘E’ represents extension and letter ‘F’ represents flexion. </p>
          <div class="table-explanation">解释：基于食指和中指的mean points生成的种子点进行FC计算。extend_序号对应了Table
            1里面的序号。extend_all表示把所有extend_x合成一个整体ROI进行FC计算。另外，flex，numb的规则和extend相同。
          </div>

          <a-divider/>

          <h1 style="color: black" id="fcrw"> FC计算结果（环指和手腕）</h1>
          <table>
            <tr class="table-sub-title">
              <td colspan="4">Ring finger</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Flex_all to Numb_1</td>
              <td>Flex_all to Numb_2</td>
              <td>Flex_all to Numb_3</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_1</td>
              <td>E: 0.569 ± 0.038<br/>F: 0.750 ± 0.046<br/>p = 0.0030</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_3</td>
              <td>-</td>
              <td>E: 0.543 ± 0.035<br/>F: 0.790 ± 0.039<br/>p &lt; 0.0001</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_3</td>
              <td>-</td>
              <td>-</td>
              <td>E: 0.415 ± 0.031<br/>F: 0.621 ± 0.044<br/>p &lt; 0.0001</td>
            </tr>
          </table>
          <table>
            <tr class="tr-title">
              <td></td>
              <td>Numb_all to Flex_1</td>
              <td>Numb_all to Flex_2</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_1</td>
              <td>E: 0.504 ± 0.036<br/>F: 0.686 ± 0.036<br/>p = 0.0005</td>
              <td>E: 0.504 ± 0.036<br/>F: 0.754 ± 0.035<br/>p &lt; 0.0001</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_2</td>
              <td> E: 0.485 ± 0.037<br/>F: 0.686 ± 0.036<br/>p = 0.0001</td>
              <td> E: 0.485 ± 0.037<br/>F: 0.754 ± 0.035<br/>p &lt; 0.0001</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_3</td>
              <td>E: 0.538 ± 0.033<br/>F: 0.686 ± 0.036<br/>P = 0.0028</td>
              <td>E: 0.538 ± 0.033<br/>F: 0.754 ± 0.035<br/>p &lt; 0.0001</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Numb_all to Flex_all</td>
              <td>p value</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numb_all to Extend_all</td>
              <td>E: 0.509 ± 0.020<br/>F: 0.720 ± 0.025</td>
              <td>p &lt; 0.0001</td>
            </tr>
          </table>
          <table>
            <tr class="table-sub-title">
              <td colspan="3">Wrist</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Flex_all to Numb_1</td>
              <td>Flex_all to Numb_2</td>
              <td>Flex_all to Numb_3</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_1</td>
              <td>E: 0.465 ± 0.042<br/>F: 0.795 ± 0.038<br/>p &lt; 0.0001</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_2</td>
              <td>-</td>
              <td>E: 0.507 ± 0.054<br/>F: 0.732 ± 0.045<br/>p = 0.0016</td>
              <td>-</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Extend_all to Numb_3</td>
              <td>-</td>
              <td>-</td>
              <td>E: 0.399 ± 0.043<br/>F: 0.612 ± 0.043<br/>p = 0.0006</td>
            </tr>
          </table>
          <table class="border-bottom2">
            <tr class="tr-title tr-title">
              <td></td>
              <td>Numb_all to Flex_1</td>
              <td>Numb_all to Flex_2</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_1</td>
              <td>E: 0.426 ± 0.040<br/>F: 0.685 ± 0.035<br/>p &lt; 0.0001</td>
              <td>E: 0.426 ± 0.040<br/>F: 0.742 ± 0.035<br/>p &lt; 0.0001</td>
            </tr>
            <tr>
              <td>Numb_all to Extend_2</td>
              <td>E: 0.488 ± 0.036<br/>F: 0.685 ± 0.035<br/>p = 0.0001</td>
              <td>E: 0.488 ± 0.036<br/>F: 0.742 ± 0.035<br/>p &lt; 0.0001</td>
            </tr>
            <tr class="table-bg-grey tr-title">
              <td></td>
              <td>Numb_all to Flex_all</td>
              <td>p value</td>
            </tr>
            <tr class="table-bg-grey">
              <td>Numb_all to Extend_all</td>
              <td>E: 0.465 ± 0.042 <br/>F: 0.795 ± 0.038</td>
              <td>p &lt; 0.0001</td>
            </tr>
          </table>
          <p style="font-size: 16px">The letter ‘E’ represents extension and letter ‘F’ represents flexion.</p>
          <div class="table-explanation">解释：基于环指和手腕的mean points生成的种子点进行FC计算。extend_序号对应了Table
            1里面的序号。extend_all表示把所有extend_x合成一个整体ROI进行FC计算。另外，flex，numb的规则和extend相同。
          </div>

          <a-divider/>
          <h1 style="color: black" id="tmssz">TMS验证健康被试伸展阳性点在MNI标准空间的坐标</h1>
          <table class="border-bottom2">
            <tr style="border-top: 2px solid black;border-bottom: 1px solid black;">
              <td colspan="3">Forefinger<br/>(n = 10)</td>
              <td colspan="3">Middle finger<br/>(n = 23)</td>
              <td colspan="3">Ring finger<br/>(n = 22)</td>
              <td colspan="3">Little finger<br/>(n = 14)</td>
              <td colspan="3">Wrist<br/>(n = 38)</td>
            </tr>
            <tr style="border-bottom: 2px solid black">
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
            </tr>
            <tr>
              <td>44</td>
              <td>-14</td>
              <td>65</td>
              <td>48</td>
              <td>4</td>
              <td>55</td>
              <td>48</td>
              <td>4</td>
              <td>55</td>
              <td>38</td>
              <td>-11</td>
              <td>67</td>
              <td>28</td>
              <td>-18</td>
              <td>77</td>
            </tr>
            <tr>
              <td>41</td>
              <td>-12</td>
              <td>67</td>
              <td>46</td>
              <td>-11</td>
              <td>63</td>
              <td>46</td>
              <td>-11</td>
              <td>63</td>
              <td>50</td>
              <td>0</td>
              <td>54</td>
              <td>26</td>
              <td>-15</td>
              <td>75</td>
            </tr>
            <tr>
              <td>38</td>
              <td>-13</td>
              <td>67</td>
              <td>43</td>
              <td>-10</td>
              <td>65</td>
              <td>43</td>
              <td>-10</td>
              <td>65</td>
              <td>26</td>
              <td>-20</td>
              <td>78</td>
              <td>32</td>
              <td>-15</td>
              <td>73</td>
            </tr>
            <tr>
              <td>46</td>
              <td>-14</td>
              <td>63</td>
              <td>38</td>
              <td>-11</td>
              <td>67</td>
              <td>38</td>
              <td>-11</td>
              <td>67</td>
              <td>28</td>
              <td>-19</td>
              <td>77</td>
              <td>43</td>
              <td>-10</td>
              <td>65</td>
            </tr>
            <tr>
              <td>26</td>
              <td>-16</td>
              <td>76</td>
              <td>41</td>
              <td>-17</td>
              <td>68</td>
              <td>26</td>
              <td>-17</td>
              <td>77</td>
              <td>35</td>
              <td>-18</td>
              <td>72</td>
              <td>43</td>
              <td>-18</td>
              <td>67</td>
            </tr>
            <tr>
              <td>27</td>
              <td>-20</td>
              <td>77</td>
              <td>26</td>
              <td>-17</td>
              <td>77</td>
              <td>23</td>
              <td>-19</td>
              <td>79</td>
              <td>32</td>
              <td>-20</td>
              <td>73</td>
              <td>17</td>
              <td>-19</td>
              <td>81</td>
            </tr>
            <tr>
              <td>39</td>
              <td>-20</td>
              <td>69</td>
              <td>23</td>
              <td>-19</td>
              <td>79</td>
              <td>50</td>
              <td>0</td>
              <td>54</td>
              <td>41</td>
              <td>-16</td>
              <td>68</td>
              <td>32</td>
              <td>-16</td>
              <td>74</td>
            </tr>
            <tr>
              <td>38</td>
              <td>-21</td>
              <td>70</td>
              <td>50</td>
              <td>0</td>
              <td>54</td>
              <td>23</td>
              <td>-18</td>
              <td>79</td>
              <td>28</td>
              <td>-18</td>
              <td>77</td>
              <td>29</td>
              <td>-18</td>
              <td>76</td>
            </tr>
            <tr>
              <td>48</td>
              <td>-10</td>
              <td>60</td>
              <td>23</td>
              <td>-18</td>
              <td>79</td>
              <td>26</td>
              <td>-20</td>
              <td>78</td>
              <td>27</td>
              <td>-17</td>
              <td>77</td>
              <td>27</td>
              <td>-20</td>
              <td>77</td>
            </tr>
            <tr>
              <td>46</td>
              <td>-10</td>
              <td>62</td>
              <td>26</td>
              <td>-20</td>
              <td>78</td>
              <td>47</td>
              <td>-4</td>
              <td>56</td>
              <td>38</td>
              <td>-20</td>
              <td>69</td>
              <td>25</td>
              <td>-15</td>
              <td>74</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>47</td>
              <td>-4</td>
              <td>56</td>
              <td>42</td>
              <td>-1</td>
              <td>62</td>
              <td>34</td>
              <td>-17</td>
              <td>70</td>
              <td>27</td>
              <td>-18</td>
              <td>76</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>45</td>
              <td>-7</td>
              <td>59</td>
              <td>28</td>
              <td>-19</td>
              <td>77</td>
              <td>44</td>
              <td>-18</td>
              <td>68</td>
              <td>48</td>
              <td>-10</td>
              <td>58</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>28</td>
              <td>-19</td>
              <td>77</td>
              <td>35</td>
              <td>-18</td>
              <td>72</td>
              <td>30</td>
              <td>-20</td>
              <td>72</td>
              <td>33</td>
              <td>-14</td>
              <td>70</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>35</td>
              <td>-18</td>
              <td>72</td>
              <td>32</td>
              <td>-20</td>
              <td>73</td>
              <td>28</td>
              <td>-18</td>
              <td>77</td>
              <td>41</td>
              <td>-17</td>
              <td>68</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>32</td>
              <td>-20</td>
              <td>73</td>
              <td>41</td>
              <td>-16</td>
              <td>68</td>
              <td></td>
              <td></td>
              <td></td>
              <td>36</td>
              <td>-13</td>
              <td>67</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>43</td>
              <td>-11</td>
              <td>65</td>
              <td>28</td>
              <td>-18</td>
              <td>77</td>
              <td></td>
              <td></td>
              <td></td>
              <td>39</td>
              <td>-13</td>
              <td>67</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>39</td>
              <td>-20</td>
              <td>69</td>
              <td>38</td>
              <td>-20</td>
              <td>69</td>
              <td></td>
              <td></td>
              <td></td>
              <td>44</td>
              <td>-11</td>
              <td>64</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>38</td>
              <td>-21</td>
              <td>70</td>
              <td>35</td>
              <td>-20</td>
              <td>71</td>
              <td></td>
              <td></td>
              <td></td>
              <td>32</td>
              <td>-21</td>
              <td>73</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>48</td>
              <td>-10</td>
              <td>60</td>
              <td>34</td>
              <td>-17</td>
              <td>70</td>
              <td></td>
              <td></td>
              <td></td>
              <td>33</td>
              <td>-23</td>
              <td>72</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>46</td>
              <td>-10</td>
              <td>62</td>
              <td>44</td>
              <td>-18</td>
              <td>68</td>
              <td></td>
              <td></td>
              <td></td>
              <td>34</td>
              <td>-19</td>
              <td>74</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>28</td>
              <td>-14</td>
              <td>74</td>
              <td>30</td>
              <td>-20</td>
              <td>72</td>
              <td></td>
              <td></td>
              <td></td>
              <td>27</td>
              <td>-20</td>
              <td>77</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>31</td>
              <td>-19</td>
              <td>75</td>
              <td>28</td>
              <td>-18</td>
              <td>77</td>
              <td></td>
              <td></td>
              <td></td>
              <td>23</td>
              <td>-20</td>
              <td>79</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>35</td>
              <td>-20</td>
              <td>71</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>30</td>
              <td>-20</td>
              <td>74</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>34</td>
              <td>-17</td>
              <td>70</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>35</td>
              <td>-20</td>
              <td>70</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>37</td>
              <td>-22</td>
              <td>70</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>29</td>
              <td>-15</td>
              <td>74</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>23</td>
              <td>-23</td>
              <td>77</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>41</td>
              <td>-19</td>
              <td>68</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>40</td>
              <td>-17</td>
              <td>68</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>38</td>
              <td>-14</td>
              <td>67</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>24</td>
              <td>-22</td>
              <td>78</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>19</td>
              <td>-22</td>
              <td>79</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>31</td>
              <td>-17</td>
              <td>75</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>35</td>
              <td>-17</td>
              <td>71</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>31</td>
              <td>-17</td>
              <td>74</td>
            </tr>
          </table>
          <a-divider/>
          <h1 style="color: black" id="tmsqq">TMS验证健康被试屈曲阳性点在MNI标准空间的坐标</h1>
          <table class="border-bottom2">
            <tr style="border-top: 2px solid black;border-bottom: 1px solid black;">
              <td colspan="3">Forefinger<br/>(n = 26)</td>
              <td colspan="3">Middle finger<br/>(n = 40)</td>
              <td colspan="3">Ring finger<br/>(n = 31)</td>
              <td colspan="3">Little finger<br/>(n = 24)</td>
              <td colspan="3">Wrist<br/>(n = 28)</td>
            </tr>
            <tr style="border-bottom: 2px solid black">
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
            </tr>
            <tr>
              <td>57</td>
              <td>-13</td>
              <td>48</td>
              <td>36</td>
              <td>-24</td>
              <td>71</td>
              <td>36</td>
              <td>-21</td>
              <td>71</td>
              <td>44</td>
              <td>-15</td>
              <td>65</td>
              <td>47</td>
              <td>-16</td>
              <td>62</td>
            </tr>
            <tr>
              <td>50</td>
              <td>-13</td>
              <td>56</td>
              <td>36</td>
              <td>-21</td>
              <td>71</td>
              <td>42</td>
              <td>-19</td>
              <td>68</td>
              <td>48</td>
              <td>-11</td>
              <td>59</td>
              <td>29</td>
              <td>-23</td>
              <td>76</td>
            </tr>
            <tr>
              <td>46</td>
              <td>-14</td>
              <td>59</td>
              <td>42</td>
              <td>-19</td>
              <td>68</td>
              <td>44</td>
              <td>-15</td>
              <td>65</td>
              <td>46</td>
              <td>-14</td>
              <td>59</td>
              <td>26</td>
              <td>-26</td>
              <td>76</td>
            </tr>
            <tr>
              <td>40</td>
              <td>-26</td>
              <td>69</td>
              <td>44</td>
              <td>-15</td>
              <td>65</td>
              <td>48</td>
              <td>-14</td>
              <td>59</td>
              <td>54</td>
              <td>-12</td>
              <td>51</td>
              <td>20</td>
              <td>-23</td>
              <td>79</td>
            </tr>
            <tr>
              <td>26</td>
              <td>-27</td>
              <td>74</td>
              <td>48</td>
              <td>-14</td>
              <td>59</td>
              <td>44</td>
              <td>-15</td>
              <td>65</td>
              <td>26</td>
              <td>-27</td>
              <td>74</td>
              <td>22</td>
              <td>-28</td>
              <td>75</td>
            </tr>
            <tr>
              <td>31</td>
              <td>-27</td>
              <td>71</td>
              <td>53</td>
              <td>-10</td>
              <td>53</td>
              <td>46</td>
              <td>-17</td>
              <td>62</td>
              <td>29</td>
              <td>-22</td>
              <td>76</td>
              <td>41</td>
              <td>-20</td>
              <td>68</td>
            </tr>
            <tr>
              <td>34</td>
              <td>-22</td>
              <td>72</td>
              <td>45</td>
              <td>-18</td>
              <td>65</td>
              <td>42</td>
              <td>-26</td>
              <td>65</td>
              <td>34</td>
              <td>-22</td>
              <td>72</td>
              <td>33</td>
              <td>-26</td>
              <td>71</td>
            </tr>
            <tr>
              <td>44</td>
              <td>-22</td>
              <td>64</td>
              <td>44</td>
              <td>-15</td>
              <td>65</td>
              <td>48</td>
              <td>-11</td>
              <td>59</td>
              <td>44</td>
              <td>-22</td>
              <td>64</td>
              <td>44</td>
              <td>-18</td>
              <td>66</td>
            </tr>
            <tr>
              <td>39</td>
              <td>-22</td>
              <td>69</td>
              <td>47</td>
              <td>-15</td>
              <td>61</td>
              <td>46</td>
              <td>-14</td>
              <td>59</td>
              <td>46</td>
              <td>-16</td>
              <td>64</td>
              <td>28</td>
              <td>-20</td>
              <td>77</td>
            </tr>
            <tr>
              <td>41</td>
              <td>-18</td>
              <td>68</td>
              <td>46</td>
              <td>-13</td>
              <td>63</td>
              <td>54</td>
              <td>-12</td>
              <td>51</td>
              <td>43</td>
              <td>-19</td>
              <td>67</td>
              <td>34</td>
              <td>-22</td>
              <td>72</td>
            </tr>
            <tr>
              <td>49</td>
              <td>-14</td>
              <td>57</td>
              <td>46</td>
              <td>-17</td>
              <td>62</td>
              <td>26</td>
              <td>-27</td>
              <td>74</td>
              <td>48</td>
              <td>-13</td>
              <td>51</td>
              <td>43</td>
              <td>-24</td>
              <td>66</td>
            </tr>
            <tr>
              <td>34</td>
              <td>-25</td>
              <td>72</td>
              <td>48</td>
              <td>-12</td>
              <td>61</td>
              <td>35</td>
              <td>-26</td>
              <td>71</td>
              <td>43</td>
              <td>-19</td>
              <td>65</td>
              <td>45</td>
              <td>-21</td>
              <td>63</td>
            </tr>
            <tr>
              <td>45</td>
              <td>-18</td>
              <td>65</td>
              <td>39</td>
              <td>-27</td>
              <td>68</td>
              <td>39</td>
              <td>-24</td>
              <td>69</td>
              <td>45</td>
              <td>-21</td>
              <td>60</td>
              <td>49</td>
              <td>-12</td>
              <td>55</td>
            </tr>
            <tr>
              <td>43</td>
              <td>-17</td>
              <td>67</td>
              <td>42</td>
              <td>-26</td>
              <td>65</td>
              <td>29</td>
              <td>-22</td>
              <td>76</td>
              <td>45</td>
              <td>-17</td>
              <td>62</td>
              <td>40</td>
              <td>-27</td>
              <td>68</td>
            </tr>
            <tr>
              <td>45</td>
              <td>-20</td>
              <td>64</td>
              <td>50</td>
              <td>-13</td>
              <td>56</td>
              <td>34</td>
              <td>-22</td>
              <td>72</td>
              <td>46</td>
              <td>-14</td>
              <td>63</td>
              <td>43</td>
              <td>-22</td>
              <td>67</td>
            </tr>
            <tr>
              <td>40</td>
              <td>-24</td>
              <td>69</td>
              <td>26</td>
              <td>-25</td>
              <td>77</td>
              <td>44</td>
              <td>-22</td>
              <td>64</td>
              <td>46</td>
              <td>-17</td>
              <td>57</td>
              <td>45</td>
              <td>-14</td>
              <td>65</td>
            </tr>
            <tr>
              <td>34</td>
              <td>-24</td>
              <td>72</td>
              <td>46</td>
              <td>-9</td>
              <td>57</td>
              <td>46</td>
              <td>-16</td>
              <td>64</td>
              <td>35</td>
              <td>-21</td>
              <td>70</td>
              <td>46</td>
              <td>-16</td>
              <td>58</td>
            </tr>
            <tr>
              <td>40</td>
              <td>-26</td>
              <td>65</td>
              <td>48</td>
              <td>-11</td>
              <td>59</td>
              <td>43</td>
              <td>-19</td>
              <td>67</td>
              <td>40</td>
              <td>-26</td>
              <td>67</td>
              <td>49</td>
              <td>-12</td>
              <td>58</td>
            </tr>
            <tr>
              <td>40</td>
              <td>-18</td>
              <td>68</td>
              <td>46</td>
              <td>-14</td>
              <td>59</td>
              <td>44</td>
              <td>-22</td>
              <td>64</td>
              <td>34</td>
              <td>-26</td>
              <td>72</td>
              <td>48</td>
              <td>-14</td>
              <td>61</td>
            </tr>
            <tr>
              <td>41</td>
              <td>-17</td>
              <td>68</td>
              <td>54</td>
              <td>-12</td>
              <td>51</td>
              <td>48</td>
              <td>-13</td>
              <td>51</td>
              <td>42</td>
              <td>-22</td>
              <td>68</td>
              <td>46</td>
              <td>-20</td>
              <td>61</td>
            </tr>
            <tr>
              <td>30</td>
              <td>-21</td>
              <td>74</td>
              <td>26</td>
              <td>-27</td>
              <td>74</td>
              <td>46</td>
              <td>-17</td>
              <td>57</td>
              <td>40</td>
              <td>-26</td>
              <td>69</td>
              <td>44</td>
              <td>-22</td>
              <td>65</td>
            </tr>
            <tr>
              <td>47</td>
              <td>-15</td>
              <td>60</td>
              <td>31</td>
              <td>-27</td>
              <td>71</td>
              <td>27</td>
              <td>-21</td>
              <td>75</td>
              <td>38</td>
              <td>-25</td>
              <td>70</td>
              <td>31</td>
              <td>-18</td>
              <td>73</td>
            </tr>
            <tr>
              <td>50</td>
              <td>-13</td>
              <td>57</td>
              <td>35</td>
              <td>-26</td>
              <td>71</td>
              <td>28</td>
              <td>-24</td>
              <td>75</td>
              <td>45</td>
              <td>-18</td>
              <td>65</td>
              <td>46</td>
              <td>-18</td>
              <td>64</td>
            </tr>
            <tr>
              <td>45</td>
              <td>-15</td>
              <td>65</td>
              <td>39</td>
              <td>-24</td>
              <td>69</td>
              <td>36</td>
              <td>-23</td>
              <td>71</td>
              <td>43</td>
              <td>-24</td>
              <td>66</td>
              <td>41</td>
              <td>-26</td>
              <td>69</td>
            </tr>
            <tr>
              <td>44</td>
              <td>-23</td>
              <td>64</td>
              <td>26</td>
              <td>-25</td>
              <td>77</td>
              <td>30</td>
              <td>-21</td>
              <td>74</td>
              <td></td>
              <td></td>
              <td></td>
              <td>42</td>
              <td>-20</td>
              <td>68</td>
            </tr>
            <tr>
              <td>47</td>
              <td>-13</td>
              <td>62</td>
              <td>29</td>
              <td>-22</td>
              <td>76</td>
              <td>34</td>
              <td>-26</td>
              <td>72</td>
              <td></td>
              <td></td>
              <td></td>
              <td>35</td>
              <td>-23</td>
              <td>71</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>34</td>
              <td>-22</td>
              <td>72</td>
              <td>45</td>
              <td>-14</td>
              <td>65</td>
              <td></td>
              <td></td>
              <td></td>
              <td>46</td>
              <td>-17</td>
              <td>60</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>44</td>
              <td>-22</td>
              <td>64</td>
              <td>40</td>
              <td>-24</td>
              <td>68</td>
              <td></td>
              <td></td>
              <td></td>
              <td>44</td>
              <td>-18</td>
              <td>66</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>46</td>
              <td>-16</td>
              <td>64</td>
              <td>42</td>
              <td>-22</td>
              <td>68</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>43</td>
              <td>-24</td>
              <td>66</td>
              <td>40</td>
              <td>-26</td>
              <td>69</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>43</td>
              <td>-19</td>
              <td>67</td>
              <td>43</td>
              <td>-24</td>
              <td>66</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>48</td>
              <td>-13</td>
              <td>51</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>27</td>
              <td>-21</td>
              <td>75</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>36</td>
              <td>-23</td>
              <td>71</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>30</td>
              <td>-21</td>
              <td>74</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>34</td>
              <td>-26</td>
              <td>72</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>42</td>
              <td>-22</td>
              <td>68</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>42</td>
              <td>-26</td>
              <td>66</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>44</td>
              <td>-22</td>
              <td>64</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>43</td>
              <td>-24</td>
              <td>66</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <a-divider/>
          <h1 style="color: black" id="fzydqssxu">辅助运动区损伤与修复（HBM，2022）</h1>
          <table style="">
            <tr class="table-title" style="border-top: 2px solid black">
              <td rowspan="2">Regions of <br/>interesting</td>
              <td rowspan="2">Modified Cyto-architectonic</td>
              <td colspan="3">Left hemisphere</td>
              <td colspan="3">Right hemisphere</td>
            </tr>
            <tr class="table-title" style="border-top: 2px solid black;border-bottom: 2px solid black">
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
            </tr>
            <tr>
              <td>A6m_ L</td>
              <td>Medial BA 6</td>
              <td>-6.0</td>
              <td>-4.5</td>
              <td>58.5</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A2_R</td>
              <td>Area BA 2</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>48.0</td>
              <td>-24.0</td>
              <td>48.0</td>
            </tr>
            <tr class="table-bg-grey">
              <td>A6m_ R</td>
              <td>Medial BA 6</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>7.5</td>
              <td>-4.5</td>
              <td>60.0</td>
            </tr>
            <tr class="table-bg-grey">
              <td>A2_L</td>
              <td>Area BA 2</td>
              <td>-46.5</td>
              <td>-30.0</td>
              <td>49.5</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
          </table>
          <p>
            *这里的LR分别指左侧和右侧。灰色的为一组连接，白色的为一组连接，分别是左侧的A6m和右侧的A2，以及右侧的A6M和左侧的A2，对应的FC见下表。</p>
          <table>
            <tr style="border-top: 2px solid black">
              <td rowspan="2">Functional Connectivity</td>
              <td colspan="3">Glioma in the left hemisphere</td>
              <td colspan="3">Glioma in the right hemisphere</td>
            </tr>
            <tr style="border-top: 2px solid black">
              <td>SMA group</td>
              <td>non-SMA group</td>
              <td>p value</td>
              <td>SMA group</td>
              <td>non-SMA group</td>
              <td>p value</td>
            </tr>
            <tr style="border-top: 2px solid black;border-bottom: 2px solid black">
              <td>A6m_H and A2_L</td>
              <td>-0.116 ± 0.040</td>
              <td>0.121 ± 0.030</td>
              <td>4.7×10 <sup>-5</sup></td>
              <td>-0.242 ± 0.077</td>
              <td>0.175 ± 0.049</td>
              <td>0.0001</td>
            </tr>
          </table>
          <p>
            *左侧半球组是右侧的A6M和左侧的A2；右侧半球组是左侧的A6m和右侧的A2。SMA组FC为负数，Non-SMA组为正数。作图的时候只用mean值就可以了。</p>

          <a-divider/>
          <h1 style="color: black" id="zcbq">左侧半球脑胶质瘤患者的感觉运动网络节点MNI坐标</h1>
          <table class="border-bottom2">
            <tr class="table-title" style="border-top: 2px solid black">
              <td rowspan="2">Regions of <br/>interesting</td>
              <td rowspan="2">Modified Cyto-architectonic</td>
              <td colspan="3">Left hemisphere</td>
              <td colspan="3">Right hemisphere</td>
            </tr>
            <tr class="table-title" style="border-top: 2px solid black;border-bottom: 2px solid black">
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
            </tr>
            <tr>
              <td>A6dl_R</td>
              <td>Dorsolateral BA 6</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>19.7</td>
              <td>4.3</td>
              <td>64.3</td>
            </tr>
            <tr>
              <td>A6m_R</td>
              <td>Medial BA 6</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>7.5</td>
              <td>-4.5</td>
              <td>60.0</td>
            </tr>
            <tr>
              <td>A6vl_R</td>
              <td>Ventrolateral BA 6</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>34.5</td>
              <td>7.5</td>
              <td>54.0</td>
            </tr>
            <tr>
              <td>A6cdl_R</td>
              <td>Caudal dorsolateral BA 6</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>33.0</td>
              <td>-7.5</td>
              <td>57.0</td>
            </tr>
            <tr>
              <td>A4ul_L(R)</td>
              <td>Area BA 4 (upper limb)</td>
              <td>-25.5</td>
              <td>-25.5</td>
              <td>63.0</td>
              <td>34.3</td>
              <td>-19.3</td>
              <td>58.7</td>
            </tr>
            <tr>
              <td>A4t_L(R)</td>
              <td>Area BA 4 (trunk)</td>
              <td>-13.3</td>
              <td>-19.7</td>
              <td>73.3</td>
              <td>15.0</td>
              <td>-22.5</td>
              <td>70.5</td>
            </tr>
            <tr>
              <td>A4tl_L(R)</td>
              <td>Area BA 4 (tongue and larynx)</td>
              <td>-52.5</td>
              <td>0.0</td>
              <td>7.5</td>
              <td>54.0</td>
              <td>4.5</td>
              <td>9.0</td>
            </tr>
            <tr>
              <td>A6cvl_L(R)</td>
              <td>Caudal ventrolateral BA 6</td>
              <td>-49.5</td>
              <td>4.5</td>
              <td>30.0</td>
              <td>51.0</td>
              <td>7.5</td>
              <td>30.0</td>
            </tr>
            <tr>
              <td>A1_2_3ll_R</td>
              <td>Area BA 1/2/3 (lower limb)</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>10.5</td>
              <td>-34.5</td>
              <td>54.0</td>
            </tr>
            <tr>
              <td>A4ll_R</td>
              <td>Area BA 4 (lower limb)</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>4.5</td>
              <td>-21.0</td>
              <td>61.5</td>
            </tr>
            <tr>
              <td>A1_2_3ulhf_L(R)</td>
              <td>Area BA 1/2/3 (upper limb and face)</td>
              <td>-49.7</td>
              <td>-16.3</td>
              <td>43.3</td>
              <td>49.7</td>
              <td>-13.7</td>
              <td>43.7</td>
            </tr>
            <tr>
              <td>A1_2_3tonIa_L(R)</td>
              <td>Area BA 1/2/3 (tongue and larynx)</td>
              <td>-55.7</td>
              <td>-13.7</td>
              <td>16.3</td>
              <td>55.5</td>
              <td>-10.5</td>
              <td>15.0</td>
            </tr>
            <tr>
              <td>A2_L(R)</td>
              <td>Area BA 2</td>
              <td>-46.5</td>
              <td>-30.0</td>
              <td>49.5</td>
              <td>48.0</td>
              <td>-24.0</td>
              <td>48.0</td>
            </tr>
            <tr>
              <td>A1_2_3tru_L(R)</td>
              <td>Area BA 1/2/3 (trunk)</td>
              <td>-21.0</td>
              <td>-34.5</td>
              <td>67.5</td>
              <td>19.5</td>
              <td>-33.0</td>
              <td>69.0</td>
            </tr>
            <tr>
              <td>A24cd_L(R)</td>
              <td>Caudodorsal area BA 24</td>
              <td>-4.7</td>
              <td>7.3</td>
              <td>37.3</td>
              <td>4.5</td>
              <td>6.0</td>
              <td>37.5</td>
            </tr>
            <tr>
              <td>A23c_L(R)</td>
              <td>Caudal area BA 23</td>
              <td>-7.3</td>
              <td>-22.7</td>
              <td>40.7</td>
              <td>6.0</td>
              <td>-19.5</td>
              <td>40.5</td>
            </tr>
            <tr>
              <td>mPMtha_L(R)</td>
              <td>Pre-motor thalamus</td>
              <td>-18.0</td>
              <td>-13.5</td>
              <td>3.0</td>
              <td>12.0</td>
              <td>-13.5</td>
              <td>1.5</td>
            </tr>
            <tr>
              <td>Stha_L(R)</td>
              <td>Sensory thalamus</td>
              <td>-18.0</td>
              <td>-22.0</td>
              <td>4.0</td>
              <td>18.0</td>
              <td>-22.5</td>
              <td>3.0</td>
            </tr>
          </table>
          <p>*BA = Brodmann area.</p>
          <a-divider/>
          <h1 style="color: black" id="ycbq">右侧半球脑胶质瘤患者的感觉运动网络节点MNI坐标</h1>
          <table class="border-bottom2">
            <tr class="table-title" style="border-top: 2px solid black">
              <td rowspan="2">Regions of <br/>interesting</td>
              <td rowspan="2">Modified Cyto-architectonic</td>
              <td colspan="3">Left hemisphere</td>
              <td colspan="3">Right hemisphere</td>
            </tr>
            <tr class="table-title" style="border-top: 2px solid black;border-bottom: 2px solid black">
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
              <td>X</td>
              <td>Y</td>
              <td>Z</td>
            </tr>
            <tr>
              <td>A6dl_L</td>
              <td>Dorsolateral BA 6</td>
              <td>-18.0</td>
              <td>-1.5</td>
              <td>64.5</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A6m_ L</td>
              <td>Medial BA 6</td>
              <td>-6.0</td>
              <td>-4.5</td>
              <td>58.5</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A6vl_ L</td>
              <td>Ventrolateral BA 6</td>
              <td>-31.7</td>
              <td>4.3</td>
              <td>55.3</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A6cdl_ L</td>
              <td>Caudal dorsolateral BA 6</td>
              <td>-31.5</td>
              <td>-9.0</td>
              <td>58.5</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A4ul_L(R)</td>
              <td>Area BA 4 (upper limb)</td>
              <td>-25.5</td>
              <td>-25.5</td>
              <td>63.0</td>
              <td>34.3</td>
              <td>-19.3</td>
              <td>58.7</td>
            </tr>
            <tr>
              <td>A4t_L(R)</td>
              <td>Area BA 4 (trunk)</td>
              <td>-13.3</td>
              <td>-19.7</td>
              <td>73.3</td>
              <td>15.0</td>
              <td>-22.5</td>
              <td>70.5</td>
            </tr>
            <tr>
              <td>A4tl_L(R)</td>
              <td>Area BA 4 (tongue and larynx)</td>
              <td>-52.5</td>
              <td>0.0</td>
              <td>7.5</td>
              <td>54.0</td>
              <td>4.5</td>
              <td>9.0</td>
            </tr>
            <tr>
              <td>A6cvl_L(R)</td>
              <td>Caudal ventrolateral BA 6</td>
              <td>-49.5</td>
              <td>4.5</td>
              <td>30.0</td>
              <td>51.0</td>
              <td>7.5</td>
              <td>30.0</td>
            </tr>
            <tr>
              <td>A1_2_3ll_ L</td>
              <td>Area BA 1/2/3 (lower limb)</td>
              <td>-7.7</td>
              <td>-37.7</td>
              <td>58.3</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A4ll_ L</td>
              <td>Area BA 4 (lower limb)</td>
              <td>-4.3</td>
              <td>-22.7</td>
              <td>61.3</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>A1_2_3ulhf_L(R)</td>
              <td>Area BA 1/2/3 (upper limb and face)</td>
              <td>-49.7</td>
              <td>-16.3</td>
              <td>43.3</td>
              <td>49.7</td>
              <td>-13.7</td>
              <td>43.7</td>
            </tr>
            <tr>
              <td>A1_2_3tonIa_L(R)</td>
              <td>Area BA 1/2/3 (tongue and larynx)</td>
              <td>-55.7</td>
              <td>-13.7</td>
              <td>16.3</td>
              <td>55.5</td>
              <td>-10.5</td>
              <td>15.0</td>
            </tr>
            <tr>
              <td>A2_L(R)</td>
              <td>Area BA 2</td>
              <td>-46.5</td>
              <td>-30.0</td>
              <td>49.5</td>
              <td>48.0</td>
              <td>-24.0</td>
              <td>48.0</td>
            </tr>
            <tr>
              <td>A1_2_3tru_L(R)</td>
              <td>Area BA 1/2/3 (trunk)</td>
              <td>-21.0</td>
              <td>-34.5</td>
              <td>67.5</td>
              <td>19.5</td>
              <td>-33.0</td>
              <td>69.0</td>
            </tr>
            <tr>
              <td>A24cd_L(R)</td>
              <td>Caudodorsal area BA 24</td>
              <td>-4.7</td>
              <td>7.3</td>
              <td>37.3</td>
              <td>4.5</td>
              <td>6.0</td>
              <td>37.5</td>
            </tr>
            <tr>
              <td>A23c_L(R)</td>
              <td>Caudal area BA 23</td>
              <td>-7.3</td>
              <td>-22.7</td>
              <td>40.7</td>
              <td>6.0</td>
              <td>-19.5</td>
              <td>40.5</td>
            </tr>
            <tr>
              <td>mPMtha_L(R)</td>
              <td>Pre-motor thalamus</td>
              <td>-18.0</td>
              <td>-13.5</td>
              <td>3.0</td>
              <td>12.0</td>
              <td>-13.5</td>
              <td>1.5</td>
            </tr>
            <tr>
              <td>Stha_L(R)</td>
              <td>Sensory thalamus</td>
              <td>-18.0</td>
              <td>-22.0</td>
              <td>4.0</td>
              <td>18.0</td>
              <td>-22.5</td>
              <td>3.0</td>
            </tr>
          </table>
          <p>*BA = Brodmann area.</p>
          <a-divider/>
          <img src="../../../assets/statistic/stat1.png" style="width: 100%"/>
          <p>Figure 1. 存在组间节点属性差异的节点情况（肿瘤位于左侧半球）。Node No. 2 (dark yellow) = medial BA
            6（坐标：7.5，-4.5，60.0）; node No. 3 (pink) = ventrolateral BA 6（坐标：34.5，7.5，54.0）; node No. 5 (green) =
            upper
            limb of BA 4（坐标：-25.5，-25.5，63.0）; node No. 7 (orange) = trunk region of BA 4（坐标：-13.3,-19.7, 73.3）;
            node
            No. 11 (light blue) = caudal ventrolateral BA 6（坐标：-49.5，4.5，30.0）; node No. 15 (light yellow) = left
            hemispheric upper limb and face of BA1/2/3（坐标：-49.7，-16.3，43.3）; node No. 16 (dark blue) = right
            hemispheric
            upper limb and face of BA 1/2/3（坐标：49.7，-13.7，43.7）; node 25 (black) = caudal area BA 23 (cingulate
            cortex)（坐标：-7.3，-22.7，40.7）. BA = Brodmann area.</p>
          <br/><br/><br/><br/>
          <img src="../../../assets/statistic/stat2.png" style="width: 100%">
          <p>Figure 2. 存在组间节点属性差异的节点情况（肿瘤位于右侧半球）. Node No. 2 (dark yellow) = medial BA
            6（坐标：-6.0，-4.5，58.5）; node No. 4 (pink) = caudal dorsolateral BA 6（坐标：-31.5，-9.0，58.5）; node No. 5 (dark
            green) = left hemispheric upper limb of BA 4（坐标：-25.5，-25.5，63.0）; node No. 6 (light green) = right
            hemispheric upper limb of BA 4（坐标：34.3，-19.3，58.7）; node No. 7 (orange) = trunk region of BA
            4（坐标：-13.3，-19.7，73.3）; node No. 8 (brown) = trunk region of BA 4（坐标：15.0，-22.5，70.5）; node No. 12
            (light
            blue) = caudal ventrolateral BA 6（坐标：51.0，7.5，30.0）; node No. 15 (light yellow) = left hemispheric upper
            limb
            and face of BA 1/2/3（坐标：-49.7，-16.3，43.3）; node No. 16 (dark blue) = right hemispheric upper limb and face
            of
            BA 1/2/3（坐标：49.7，-13.7，43.7）; node 26 (black) = caudal area BA 23 (cingulate cortex) （坐标：6.0，-19.5，40.5）.
            BA
            = Brodmann area.</p>
          <div style="height: 200px"></div>
        </div>
      </a-col>
    </a-row>
  </v-nav>
</template>

<script>
import VNav from "@/components/public/VNav.vue";

export default {
  name: "statisticsPage",
  components: {VNav},
  data() {
    return {
      contentHeight: ""
    }
  },
  mounted() {
    this.computedHeight();
  },
  methods: {
    computedHeight() {
      this.contentHeight = (window.innerHeight - 48) + "px";
    },
    handleAnchorClick(e, link) {
      // 阻止点击的默认事件修改路由
      e.preventDefault();
      var srcolls = document.getElementById(link.href);
      srcolls.scrollIntoView({block: 'start', behavior: 'smooth'});
    },
  }
}
</script>

<style scoped>
table, table tr th, table tr td {
  border: 1px dashed darkgray;

}

table {
  width: 100%;
  font-size: 16px;
  color: black;
  text-align: center;
  border-collapse: collapse;
}

.table-title {
  font-weight: bold;
  font-size: 16px;
}

.table-explanation {
  font-size: 16px;
  color: black;
}

.table-bg-grey {
  background-color: lightgrey;
}

.table-sub-title {
  font-weight: bold;
  text-align: left;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
}

.tr-title {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.border-bottom2 {
  border-bottom: 2px solid black;
}
</style>